import {
	generateUtilityClass,
	generateUtilityClasses,
} from '@netx/core-components/Theme';

export const LOGIN_CLASS_NAME = 'Login';
export const LOGIN_CLASS_SLOTS = ['root'] as const;

export type LoginClassSlot = typeof LOGIN_CLASS_SLOTS[number];

export interface LoginClasses {
	root: string;
}

export type LoginClassKey = keyof LoginClasses;

export const getLoginUtilityClass = (slot: string) =>
	generateUtilityClass(LOGIN_CLASS_NAME, slot);

export const loginClasses = generateUtilityClasses<keyof LoginClasses>(
	LOGIN_CLASS_NAME,
	['root'],
);
export default loginClasses;
